<template>
    <div class="user-profile-answer-and-question-wrap mb-40px">
        <div class="row">
            <div class="col-md-6">
                <div class="user-profile-answer-wrapper">
                    <div class="user-profile-answer-header mb-20px bg-gray p-3 radius-4 d-flex align-center justify-content-between">
                        <h1 class="fs-17 d-flex justify-content-between flex-column">
                            Answers
                            <a href="#" class="simple-text-btn mt-5px">View all answers</a>
                        </h1>
                        <el-select v-model="softValue" placeholder="Select" size="large">
                            <el-option
                                v-for="item in sortFilter"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                />
                        </el-select>
                    </div>

                    <div class="user-profile-answer-lists">
                        <question-and-answer-box :items="answers" />
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="user-profile-answer-wrapper">
                    <div class="user-profile-answer-header mb-20px bg-gray p-3 radius-4 d-flex align-center justify-content-between">
                        <h1 class="fs-17 d-flex justify-content-between flex-column">
                            Questions
                            <a href="#" class="simple-text-btn mt-5px">View all questions</a>
                        </h1>
                        <el-select v-model="softQuestionValue" placeholder="Select" size="large">
                            <el-option
                                v-for="item in sortQuestionFilter"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                />
                        </el-select>
                    </div>

                    <div class="user-profile-answer-lists">
                        <question-and-answer-box :items="questions" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuestionAndAnswerBox from "../../cards/QuestionAndAnswerBox.vue"

export default {
    name: 'UserProfileAnswerQuestion',
    components: { 
        QuestionAndAnswerBox
    },
    data() {
        return {
            softValue: 'score',
            softQuestionValue: 'score',
            sortFilter: [
                {
                    value: 'score',
                    label: 'Score',
                },
                {
                    value: 'activity',
                    label: 'Activity',
                },
                {
                    value: 'newest',
                    label: 'Newest',
                }
            ],
            sortQuestionFilter: [
                {
                    value: 'score',
                    label: 'Score',
                },
                {
                    value: 'activity',
                    label: 'Activity',
                },
                {
                    value: 'newest',
                    label: 'Newest',
                },
                {
                    value: 'views',
                    label: 'Views',
                }
            ],
            answers: [
                {
                    id: 1,
                    title: 'Blur rectangle-shaped div edges?',
                    date: 'Jan 7, 2019',
                    count: 4,
                    isAnswered: true
                },
                {
                    id: 2,
                    title: "Dropdown menu won't appear in elementor Wordpress",
                    date: 'AUg 5, 2019',
                    count: 4,
                    isAnswered: true
                },
                {
                    id: 3,
                    title: "CSS dropdown menu disappears when using bootstrap carousel",
                    date: 'Jun 3, 2020',
                    count: 5,
                    isAnswered: true
                },
                {
                    id: 4,
                    title: "Image resizing distorted in Safari on iOS",
                    date: 'Jun 10, 2020',
                    count: 1,
                    isAnswered: false
                },
                {
                    id: 5,
                    title: "How to add space between border line and object above the border [html]",
                    date: 'Apr 29, 2021',
                    count: 9,
                    isAnswered: true
                }
            ],
            questions: [
                {
                    id: 1,
                    title: 'foreach loop working but category_name not looping inside of Wp_Query :(',
                    date: 'Sep 9, 2019',
                    count: 4,
                    isAnswered: true
                },
                {
                    id: 2,
                    title: "How to query all custom post type + post and page in WordPress",
                    date: 'Sep 19, 2019',
                    count: 4,
                    isAnswered: false
                },
                {
                    id: 3,
                    title: "Uncaught SyntaxError: Unexpected token '!'",
                    date: 'Jun 14, 2020',
                    count: 1,
                    isAnswered: true
                },
                {
                    id: 4,
                    title: "Leaflet Route Map direction",
                    date: 'Apr 22, 2021',
                    count: 0,
                    isAnswered: false
                },
                {
                    id: 5,
                    title: "Retrieve data using query from all WordPress pages",
                    date: 'Sep 17, 2019',
                    count: 0,
                    isAnswered: true
                }
            ]
        }
    }
}
</script>